<div class="dropdown d-inline-block vm-table-action"
     [ngClass]="{'dropup' :isChild &&  (browserHeight - (screenHeight)) < 0}">
  <div class="dropdown dropdown-with-icons d-inline-block" [ngClass]="{'show' : ispopupopen}"
       (clickOutside)="closedropdownBlock($event)">
    <a (click)="toggleDropdown($event)" [ngClass]="{'isDisabled' : disabled}" role="button">
      <ng-container *ngIf="imageurl !=''; then image; else default">
      </ng-container>
      <ng-template #image>
        <span>
          <img src="{{imageurl}}"  alt="image" height="20px" width="20px" />
        </span>
      </ng-template>
      <ng-template #default>
        <div *ngIf="orientation=='Horizontal'">
          <svg viewBox="0 0 16 4" width="16" height="4">
            <path data-name="more copy 2"
                  d="M14 0a2 2 0 11-2 2 2 2 0 012-2zM8 0a2 2 0 11-2 2 2 2 0 012-2zM2 0a2 2 0 11-2 2 2 2 0 012-2z"
                  fill="#4f596f" fill-rule="evenodd"></path>
          </svg>
        </div>
      </ng-template>
      <img *ngIf="orientation=='Vertical'" src="assets/img/dot-menu.svg"  alt="image">
    </a>
    <div #getResolution class="dropdown-menu dropdown-menu-arrow"
         [ngClass]="{ 'show': ispopupopen,'dropdown-menu-right' : (browserWidth - (screenWidth + getResolution.offsetWidth)) < 0}" [style]="style">
      <div class="dropdown-close" (click)="closedropdownBlock($event)">
        <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="10" height="10" viewBox="0 0 16 16">
          <path d="M3 0L0 2l6 6-6 6 3 2 5-5V5z" fill-rule="evenodd" fill="#ff4b38"></path>
          <path data-name="close copy" d="M13 0l3 2-6 6 6 6-3 2-5-5V5z" fill="#ff4b38" fill-rule="evenodd"></path>
        </svg>
      </div>
      <div class="overflow-menu-panel">
        <ng-container *ngIf="iscomplex; then complex_data; else non_complex_data">
        </ng-container>
          <ng-template #non_complex_data>
            <a [ngClass]="{'active' : item == selectedbutton}" *ngFor="let item of data" (click)="buttonClick(item)"
               class="dropdown-item">
              {{ item }}
            </a>
          </ng-template>
          <ng-template #complex_data>
            <a [ngClass]="{'active' : item[valuefield] == selectedbutton}" *ngFor="let item of data"
               (click)="buttonClick(item)" class="dropdown-item">
              <ng-container *ngIf="item[valuefield]">
                <span *ngIf="fileType=='Image'" class="vm-dropDownicons">
                  <img src="{{item[valuefield]}}" height="auto" width="16px"  alt="image"/>
                </span>
              </ng-container>
              <ng-container *ngIf="item[valuefield]">
                <span *ngIf="fileType=='Icon'" class="material-symbols-outlined vm-icon">{{item[valuefield]}}</span>
              </ng-container>
              {{ item[textfield] }}
            </a>
          </ng-template>
        </div>
      </div>
    </div>
</div>
